import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StaticDataApiService } from 'src/helper/static-data.service';

@Component({
  selector: 'app-spanish-itim',
  templateUrl: './spanish-itim.component.html',
  styleUrls: ['./spanish-itim.component.css']
})
export class SpanishItimComponent implements OnInit {
  linkarrays : any;

  constructor(private route : ActivatedRoute,private staticdata : StaticDataApiService,
    private router : Router) { }

  ngOnInit(): void {
    let details = this.staticdata.getspanishModuleByModuleName('spanish-translations');
    this.linkarrays = details?.detailpage.links;

  }
  booklink(linkname){
    return "/spanish-itim-ministry/" + linkname;
  }

}
